import React, { FC, useEffect, useRef, useState } from 'react'
import { TabsPanel } from '../../../../../components/tabs'
import { ITabsPanelAction, ITabsPanelState, useDetailsTabsPanel } from '../../../../../system/hooks/useTabsPanel'
import CashRegistersPluginSettings from '../../CashRegistersPluginSettings'
import classNames from "classnames";
import tabsStyles from '../../../../../pages/styles//homePage.module.scss'
import { BunchModalContent } from './BunchDB/BunchModalContent'
import { SettingsAdditionalModalContent } from './SettingsAdditional/SettingsAdditionalModalContent'
import { IAdditionalSettingsViewDTO, ICashRegisterCreate } from '../../../../../libs/coreapi-dto/service/cashRegisters'
import { v4 as uuidv4 } from 'uuid';
import { TypeOpen } from '../../CashRegistersPluginView'
import { useAppContext } from '../../../../../system/providers/appContextProvider'
import { CashRegisterDataProvider } from '../../../../../Services/DataProviders/CashRegisterDataProvider'
import { ICashRegister2StoreViewDTO, ICashRegister2StoreCreate, ICashRegister2StoreDTO } from '../../../../../libs/coreapi-dto/service/cashRegister2Store'
import { CashRegister2StoreDataProvider } from '../../../../../Services/DataProviders/CashRegister2StoreDataProvider'
import useGridFilter, { GridFilterAction } from '../../../../../system/hooks/useGridFilter'
import { LoadingStatus } from '../../../../../@types/enumsGlobal'
import { DocumentGridStateType } from '../../../../../@types/documents'
import { useForm } from '../../../../../system/hooks/useForm'
import { useTranslation } from 'react-i18next'
import { GridSelectorModalWindow } from '../../../../../components/modalWindows/GridSelectorModalWindow'

interface ISettingKkmModalProps {
    selectedCashRegisterItem: [IGridRow | undefined, (row: IGridRow | undefined) => void]
    refresh: () => void
    cancel: () => void
    typeOpen: TypeOpen
    lockFromPermission?: boolean
    setTypeOpen: (value: TypeOpen) => void
}

interface ISettingKkmContentProps {
    detailsTabsPanel: ITabsPanelState,
    dispatchDetailsTabsPanel: (data: ITabsPanelAction) => void,
    selectedCashRegisterItem: [IGridRow | undefined, (row: IGridRow | undefined) => void]
    createBody: [ICashRegisterCreate, (createBody: ICashRegisterCreate) => void]
    cashRegister2Store: [ICashRegister2StoreViewDTO[], (value: ICashRegister2StoreViewDTO[], idContractorGlobal?: string) => void]
    deletedStores: [
        { idCashRegister2StoreGlobal: string, idStoreGlobal: string }[],
        (value: { idCashRegister2StoreGlobal: string, idStoreGlobal: string }[]) => void
    ]
    typeOpen: TypeOpen
    loadingStoreStatus: LoadingStatus
    refresh: () => void
    gridFilterCashRegister2Store: [IGridFilter, (value: GridFilterAction) => void]
    errors: Partial<Record<keyof ICashRegisterCreate, string>>
    setErrors: React.Dispatch<React.SetStateAction<Partial<Record<keyof ICashRegisterCreate, string>>>>
    lockFromPermission?: boolean
    totalCount:number
    storesDisabled:ICashRegister2StoreViewDTO[]
    onChangeData: (data: ICashRegister2StoreViewDTO[]) => void
    additionalSettingsValid: [boolean, (isValid: boolean) => void]
    additionalSettingsErrors: [string[], (errors: string[]) => void]
}

const getGridFilterCashRegister2Store = (value: string): IGridFilter => {
    if (value) {
        return {
            numberPerPage: 10,
            pageNumber: 1,
            columnFilters: [
                { name: 'idCashRegisterGlobal', value: value, operator: 'Eq' },
                {
                    "name": "deleted",
                    "value": "false",
                    "operator": "Eq"
                }
            ]
        }
    } else {
        return {
            numberPerPage: 10,
            pageNumber: 1,
            columnFilters: []
        }
    }
}

export const SettingKkmModal: FC<ISettingKkmModalProps> = (props) => {
    const appContext = useAppContext();
    const { t } = useTranslation();

    const cashRegisterDataProvider = new CashRegisterDataProvider(appContext.coreApiService);
    const cashRegister2StoreDataProvider = new CashRegister2StoreDataProvider(appContext.coreApiService);

    const [detailsTabsPanel, dispatchDetailsTabsPanel] = useDetailsTabsPanel(CashRegistersPluginSettings.mnemocode);
    const [createBody, setCreateBody] = useState<ICashRegisterCreate>({ rvEnable: true } as ICashRegisterCreate)
    const [cashRegister2Store, setCashRegister2Store] = useState<ICashRegister2StoreViewDTO[]>([]);
    const [storesDisabled, setStoresDisabled] = useState<ICashRegister2StoreViewDTO[]>([]);
    const [totalCount, setTotalCount] = useState<number>(0);

    const [gridFilterCashRegister2Store, dispatchGridFilterCashRegister2Store] =
        useGridFilter(getGridFilterCashRegister2Store(props.selectedCashRegisterItem[0]?.idGlobal as string));

    const [deletedStoreArr, setDeletedStoreArr] = useState<{ idCashRegister2StoreGlobal: string, idStoreGlobal: string }[]>([])
    const [loadingStoreStatus, setLoadingStoreStatus] = useState<LoadingStatus>(LoadingStatus.InProcess)
    const [viewState, setViewState] = useState<DocumentGridStateType>('view')

    const [createdCashRegisterIdGlobal, setCreatedCashRegisterIdGlobal] = useState("");
    const docTypeForDeleteDoc = useRef(props.typeOpen); //Значение необходимое для удаления док-та в случае его отмены в статусе "Create";

    const [isAdditionalSettingsValid, setIsAdditionalSettingsValid] = useState<boolean>(true);
    const [additionalSettingsErrors, setAdditionalSettingsErrors] = useState<string[]>([]);

    const errorsT = (value: string) => t('errors.' + value);

    const { isValid, errors, setErrors } = useForm<ICashRegisterCreate>({
        validations: {
            idContractorGlobal: {
                required: {
                    value: !(createBody.idContractorGlobal?.length > 0),
                    message: errorsT("required")
                }
            },
            nameCashRegister: {
                required: {
                    value: !(createBody.nameCashRegister?.length > 0),
                    message: errorsT("required")
                }
            }
        }
    });

    const isAllValid = () => {
        return isValid() && isAdditionalSettingsValid;
    };

    const loadData = () => {
        setLoadingStoreStatus(LoadingStatus.InProcess)
        if (props.typeOpen === 'Edit') {
            if (props.selectedCashRegisterItem[0]?.idGlobal) {
                cashRegisterDataProvider.getViewById(props.selectedCashRegisterItem[0].idGlobal, () => {
                }, (result: ICashRegisterCreate) => {
                    setCreateBody(result)
                    loadCashRegister2StoreData()
                })
            }
        } else if (props.typeOpen === 'Copy') {
            if (props.selectedCashRegisterItem[0]?.idGlobal) {
                cashRegisterDataProvider.getViewById(props.selectedCashRegisterItem[0].idGlobal, () => {
                }, (result: ICashRegisterCreate) => {
                    setCreateBody({...result, idGlobal: uuidv4()})
                    loadCashRegister2StoreData()
                })
            }
        } else {
            setLoadingStoreStatus(LoadingStatus.NoData)
        }
    }

    const loadCashRegister2StoreData = (typeOpen: TypeOpen = props.typeOpen, customGridFilter?: IGridFilter) => {
        const createMode: boolean = (typeOpen === 'Create' && createdCashRegisterIdGlobal?.length > 0);
        const gridFilter: IGridFilter = createMode ? {
            numberPerPage: 10,
            pageNumber: 1,
            columnFilters: [
                { name: 'idCashRegisterGlobal', value: createdCashRegisterIdGlobal, operator: 'Eq' },
                {
                    "name": "deleted",
                    "value": "false",
                    "operator": "Eq"
                }
            ]
        } : gridFilterCashRegister2Store;

        if (typeOpen === 'Edit' || createMode) {
            setLoadingStoreStatus(LoadingStatus.InProcess)
            try {
                function generateResult(result: ICashRegister2StoreDTO[]): ICashRegister2StoreViewDTO[] {
                    return result.map(x => ({
                        idGlobal: x.idGlobal,
                        idStoreGlobal: x.idStoreGlobal,
                        onlyView: x.onlyView,
                        storeName: x.storeName
                    }));
                }
                // Получение сохранённых складов.
                cashRegister2StoreDataProvider.getCashRegister2Stores(customGridFilter || gridFilter, (result: ICashRegister2StoreDTO[], totalCount: number) => {
                    if (result.length) {
                        // Получение ВСЕХ сохранённых складов для блокировки отображения складов в компонененте BunchModalContent.
                        cashRegister2StoreDataProvider.getCashRegister2Stores({ ...(customGridFilter || gridFilter), numberPerPage: totalCount, pageNumber: 1 }, (allResults: ICashRegister2StoreDTO[]) => {
                            if (allResults.length) {
                                const disabledStores: ICashRegister2StoreViewDTO[] = generateResult(allResults);
                                const cahsResult: ICashRegister2StoreViewDTO[] = generateResult(result);
                                
                                setStoresDisabled(disabledStores);
                                setCashRegister2Store(cahsResult);
                                setTotalCount(totalCount);
                                setLoadingStoreStatus(LoadingStatus.Completed);
                            }
                        })
                    } else {
                        setCashRegister2Store([])
                        setTotalCount(0);
                        setLoadingStoreStatus(LoadingStatus.NoData);
                    }
                })
            } catch {
                setLoadingStoreStatus(LoadingStatus.Failed);
            }
        } else {
            setCashRegister2Store([])
            setTotalCount(0);
            setLoadingStoreStatus(LoadingStatus.NoData);
        }
    }

    useEffect(() => {
        if (viewState === 'refresh') {
            loadCashRegister2StoreData();
            setViewState('view');
        }
    }, [viewState])

    useEffect(() => {
        if (cashRegister2Store.length > 0) {
            setLoadingStoreStatus(LoadingStatus.Completed);
        } else {
            setLoadingStoreStatus(LoadingStatus.NoData);
        }
    }, [cashRegister2Store])

    useEffect(() => {
        if (props.typeOpen === 'Edit') {
            loadCashRegister2StoreData();
        } else {
            setLoadingStoreStatus(LoadingStatus.NoData);
        }
    }, [gridFilterCashRegister2Store])

    useEffect(() => {
        if (props.typeOpen === 'Edit' || props.typeOpen === 'Copy') {
            loadData();
        } else {
            setLoadingStoreStatus(LoadingStatus.NoData);
        }
    }, [])

     // Для закрытия окна и перезагрузки страницы.
     const hideOrNot = (hideModal: boolean) => {
        if (hideModal) {
            props.refresh();
            props.cancel();
        }
    }
    const createDocument = (hideModal: boolean) => {
        cashRegisterDataProvider.create(createBody, (idGlobal) => {
            hideOrNot(hideModal)
        });
    };
    const updateDocument = (hideModal: boolean) => {
        cashRegisterDataProvider.update(createBody.idGlobal, createBody, async () => {
            hideOrNot(hideModal)
        })
    };
    // Логика при работе с документом.
    const documentService: {
        createDocument: (hideModal: boolean) => void,
        updateDocument: (hideModal: boolean) => void,
    } = { createDocument, updateDocument };
       
     
    // Данная функция сработает 1 раз при создании документа!
    const createDocumentWithStores = (stores: ICashRegister2StoreViewDTO[], idContractorGlobal: string) => {
        if (props.typeOpen === 'Create') {
            // Создание документа добавление idContractorGlobal и idGlobal.
            cashRegisterDataProvider.create({...createBody, idContractorGlobal: idContractorGlobal}, (idGlobal) => {

                if (idGlobal?.length > 0) {
                    setCreatedCashRegisterIdGlobal(idGlobal);
                    setCreateBody({ ...createBody, idGlobal: idGlobal, idContractorGlobal })
                    props.setTypeOpen('Edit')
                }

                let cashRegisterStores: ICashRegister2StoreCreate[] = [...stores.map(x => ({ idStoreGlobal: x.idStoreGlobal, onlyView: x.onlyView }))]
                if (cashRegisterStores.length > 0) {
                    // Добавление складов
                    cashRegister2StoreDataProvider.createCashRegister2Store(idGlobal, cashRegisterStores, () => {
                        const gridFilter: IGridFilter = {
                            numberPerPage: 10,
                            pageNumber: 1,
                            columnFilters: [
                                { name: 'idCashRegisterGlobal', value: idGlobal, operator: 'Eq' },
                                {
                                    "name": "deleted",
                                    "value": "false",
                                    "operator": "Eq"
                                }
                            ]
                        }
                        dispatchGridFilterCashRegister2Store({ type: 'newGridFilters', payload: gridFilter });
                        loadCashRegister2StoreData('Edit', gridFilter);// Напрямую передаю Тип и gridFilter чтобы не было рассинхрона.
                    })
                } else {
                    loadCashRegister2StoreData()
                }
            })
        }
    }
    const updateStores = (stores: ICashRegister2StoreViewDTO[]) => {
        // Изменение складов
        if (stores.length > 0) {
            cashRegister2StoreDataProvider.createCashRegister2Store(createBody.idGlobal, stores, () => {
                loadCashRegister2StoreData();
            });
        };
    };
    const removeStores = (stores) => {
        // Удаление складов
        if (stores.length > 0) {
            cashRegister2StoreDataProvider.batchDelete(stores.map(x => x.idStoreGlobal), (result: boolean) => {
                loadCashRegister2StoreData();
            });
        }
    };
    const storeService = { createDocumentWithStores, updateStores, removeStores };

    return (
        <>
            <GridSelectorModalWindow
                gridDisplayName={t("modals.settingKkm.header")}
                fullScreen
                modalKey='settingKkmModal'
                ok={{
                    onClick: () => {
                        if (!isAllValid()) return
                        props.typeOpen === 'Create' && createdCashRegisterIdGlobal.length === 0 ? documentService.createDocument(true) : documentService.updateDocument(true)
                    },
                    disabled: props.lockFromPermission
                }}
                cancel={{
                    onClick: () => {
                        // Логика для удаления документа при типе "Create" если пользователь не нажал кнопку ok.
                        if (docTypeForDeleteDoc.current === 'Create' && createBody.idGlobal) {
                            cashRegisterDataProvider.deleteById(createBody.idGlobal as string, () => {
                                props.cancel?.();
                            })
                            return;
                        }
                        props.cancel?.();
                        createBody.idGlobal && props.refresh();
                    }
                }}
            >
                <SettingKkmContent
                    totalCount={totalCount}
                    detailsTabsPanel={detailsTabsPanel}
                    dispatchDetailsTabsPanel={(data) => dispatchDetailsTabsPanel(data)}
                    selectedCashRegisterItem={[props.selectedCashRegisterItem[0], (row: IGridRow | undefined) => props.selectedCashRegisterItem[1](row)]}
                    createBody={[createBody, (value: ICashRegisterCreate) => setCreateBody(value)]}
                    cashRegister2Store={[cashRegister2Store, (value: ICashRegister2StoreViewDTO[], idContractorGlobal?: string) => {
                        // Добавление складов.
                        props.typeOpen === 'Create' && createdCashRegisterIdGlobal.length === 0 ? storeService.createDocumentWithStores(value, idContractorGlobal as string) : storeService.updateStores(value);
                    }]}
                    typeOpen={props.typeOpen}
                    loadingStoreStatus={loadingStoreStatus}
                    errors={errors}
                    setErrors={setErrors}
                    refresh={() => {
                        setViewState('refresh');
                        setCashRegister2Store([]);
                    }}
                    gridFilterCashRegister2Store={[gridFilterCashRegister2Store, (value: GridFilterAction) => dispatchGridFilterCashRegister2Store(value)]}
                    deletedStores={[deletedStoreArr, (value: { idCashRegister2StoreGlobal: string, idStoreGlobal: string }[]) => storeService.removeStores(value)]}
                    lockFromPermission={props.lockFromPermission}
                    storesDisabled={storesDisabled}
                    onChangeData={(data) => {setCashRegister2Store(data); setStoresDisabled(data)}}
                    additionalSettingsValid={[isAdditionalSettingsValid, setIsAdditionalSettingsValid]}
                    additionalSettingsErrors={[additionalSettingsErrors, setAdditionalSettingsErrors]}
                />
            </GridSelectorModalWindow>
        </>
    )
}

const SettingKkmContent: FC<ISettingKkmContentProps> = (props) => {
    const { t } = useTranslation();
    return (
        <div>
            {
                props.detailsTabsPanel.tabs.length > 0 &&
                <>
                    <TabsPanel
                        id="detailsTabsPanel"
                        activeId={props.detailsTabsPanel.currentTab?.id}
                        tabs={props.detailsTabsPanel.tabs}
                        onActive={(id) => { props.dispatchDetailsTabsPanel({ type: "activate", payload: id }) }}
                    />
                    <div>
                        {props.detailsTabsPanel.tabs.map((item, i) => {
                            return (
                                <div
                                    key={item.id}
                                    className={classNames(item.id === props.detailsTabsPanel.currentTab?.id ? tabsStyles.contentVisible : tabsStyles.contentHidden)}
                                >
                                    {
                                        item.title === t("modals.bunchTab.dbTitle") ?
                                            <BunchModalContent
                                                totalCount={props.totalCount}
                                                selectedCashRegisterItem={props.selectedCashRegisterItem[0]}
                                                errors={props.errors}
                                                setErrors={props.setErrors}
                                                createBody={props.createBody[0]}
                                                setCreateBody={(value) => props.createBody[1](value)}
                                                cashRegister2Store={props.cashRegister2Store[0]}
                                                setCashRegister2Store={(value: ICashRegister2StoreViewDTO[], idContractorGlobal?: string) => props.cashRegister2Store[1](value, idContractorGlobal)}
                                                onChangeData={props.onChangeData}
                                                typeOpen={props.typeOpen}
                                                loadingStatus={props.loadingStoreStatus}
                                                refresh={() => props.refresh()}
                                                gridFilter={props.gridFilterCashRegister2Store[0]}
                                                dispatchGridFilter={(value: GridFilterAction) => props.gridFilterCashRegister2Store[1]((value))}
                                                setDeletedStores={(value: { idCashRegister2StoreGlobal: string, idStoreGlobal: string }[]) => props.deletedStores[1](value)}
                                                lockFromPermission={props.lockFromPermission}
                                                validateDifferentContractors
                                                storesDisabled={props.storesDisabled}
                                            /> :
                                            <SettingsAdditionalModalContent
                                                lockFromPermission={props.lockFromPermission}
                                                cashRegisterDto={props.createBody[0]}
                                                setRegisterDto={(dto) => props.createBody[1](dto)}
                                                onValidationChange={(isValid, errors) => {
                                                    props.additionalSettingsValid[1](isValid);
                                                    props.additionalSettingsErrors[1](errors);
                                                }}
                                            />
                                    }
                                </div>
                            )
                        })}
                    </div>
                </>
            }
        </div>
    )
}